/** @format */

export default {
    TYPE: {
        SPONSORED: 'SPONSORED',
        TARGETED_SPONSORED: 'TARGETED_SPONSORED',
    },
};
